export default [
  {
    value: "WITHDRAWAL",
    key: "members.followUps.incidentFollowUpCategories.withdrawal",
  },
  {
    value: "PLAN_MODIFICATION",
    key: "members.followUps.incidentFollowUpCategories.planModification",
  },
  {
    value: "CLAIMS",
    key: "members.followUps.incidentFollowUpCategories.claims",
  },
  {
    value: "CS_QUALITY",
    key: "members.followUps.incidentFollowUpCategories.csQuality",
  },
  {
    value: "SHI_BD",
    key: "members.followUps.incidentFollowUpCategories.shiBD",
  },
  { value: "OTHER", key: "members.followUps.incidentFollowUpCategories.other" },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/notes/enums/incidentFollowUpCategories.js